type min = 'min';
type max = 'max';

interface options {
  type: min | max;
  query: string;
  onMatch: () => void;
  onUnmatch?: () => void;
}

export function useMq(obj: options) {
  class mediaquery {
    mediaquery: string;

    constructor(obj) {
      this.mediaquery = `(${obj.type}-width: ${obj.query})`;
      this.init();
    }

    init(){
      const media = window.matchMedia(this.mediaquery);
      if (media.matches) {
        this.onMatch()
      } else {
        this.onUnmatch()
      }
      media.addEventListener('change', (event) => {
        if (event.matches) {
          this.onMatch()
        } else {
          this.onUnmatch()
        }
      })
    }

    onMatch() {
      obj.onMatch()
    }

    onUnmatch() {
      obj.onUnmatch()
    }
  }

  new mediaquery(obj);
}
